import { render } from "./capitec.vue?vue&type=template&id=450b1385&scoped=true"
import script from "./capitec.vue?vue&type=script&lang=js"
export * from "./capitec.vue?vue&type=script&lang=js"

import "./capitec.vue?vue&type=style&index=0&id=450b1385&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450b1385"]])

export default __exports__